<template>
<div>
    <div style="margin: 5px; padding: 8px; width: 150px; height: 25px; border: 1px solid teal; border-radius: 3px; position: relative;" :style="{'border-width':enforce_100 ? '1px' : '0px'}">
        <template v-if="enforce_100">
            <template v-if="(total>0 && total<=100) || (total > 100 && !!disabledOverflow)">
                <div :class="$style.bar" style="left:0px; background-color: #0588EF;" :style="{'width':total > 100 && !!disabledOverflow ? 100 : total +'%'}">
                    <span v-if="displayNumber && total<100">{{total}}%</span>
                    <span v-else-if="!displayNumber && total == 100"><str index="survey > question > percentage > complete"/></span>
                    <span v-else-if="displayNumber"><str index="survey > question > percentage > complete"/></span>
                </div>
                <div :class="$style.bar" style="right:0px; background-color: #C9ECFC;" :style="{'width':(100-total)+'%'}">
                    <span v-if="displayNumber && total<100">{{100-total}}%</span>
                </div>
            </template>
            <template v-else-if="total>0 && !disabledOverflow">
                <div :class="$style.bar" style="top:0px; left:0px; width: 100%; background-color: darkred;"/>
            </template>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: 'completion-bar',
    props: {
        total: {
            type: Number,
            required: true
        },
        displayNumber: {
            type: Boolean,
            required: false,
            default: true
        },
        enforce_100: {
            type: Boolean,
            required: false,
            default: true
        },
        disabledOverflow: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style module>
.bar{
    text-align:center; 
    font-weight: bold; 
    color: white; 
    position:absolute; 
    top:0px;
    height:100%;
    transition-property: width;
    transition-duration: 0.5s;
    transition-timing-function: linear;
    transition-delay: 0s;    
}
</style>